(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["free-form-specs-table"] && !Shopify.designMode) return;
  try {
    
  const enhanceFreeFormSpecsTables = () => {
    const tables = document.querySelectorAll('[data-free-form-specs-table] table:not([data-free-form-specs-enhanced])');

    for (const table of tables) {
      table.setAttribute('data-free-form-specs-enhanced', 'true');

      const section = table.closest('[data-free-form-specs-table]');
      const captionText = section ? section.getAttribute('data-table-caption') || '' : '';

      if (table.querySelector('thead') === null) {
        const firstRow = table.querySelector('tr');

        if (firstRow) {
          const thead = document.createElement('thead');
          thead.append(firstRow);
          table.prepend(thead);
        }
      }

      if (captionText !== '' && table.querySelector('caption') === null) {
        const caption = document.createElement('caption');
        caption.className = 'visually-hidden';
        caption.textContent = captionText;
        table.prepend(caption);
      }

      const headerRow = table.querySelector('thead tr');

      if (!headerRow) continue;

      const headerCells = headerRow.querySelectorAll('td');

      for (const cell of headerCells) {
        const header = document.createElement('th');
        header.scope = 'col';
        header.append(...cell.childNodes);
        cell.replaceWith(header);
      }
    }
  };

  enhanceFreeFormSpecsTables();
  document.addEventListener('shopify:section:load', enhanceFreeFormSpecsTables);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
